import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof CustomerMasterData;
  onSort: (property: keyof CustomerMasterData) => void;
}

const commonCellStyle = {
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const headCells: { id: keyof CustomerMasterData; label: string }[] = [
  { id: "created_date", label: "Created Date" },
  { id: "contact_name", label: "Customer Name" },
  { id: "contact_number", label: "Mobile Number" },
  { id: "contact_email", label: "Email ID" },
  { id: "state", label: "State" },
  { id: "city", label: "City" },
  { id: "area", label: "Area" },
  { id: "reference", label: "Reference" },
  { id: "address", label: "Address" },
];

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  const createSortHandler = (property: keyof CustomerMasterData) => () => {
    onSort(property);
  };

  return (
    <TableHeader>
      {/* Uncomment this if you want an Action column
      <TableCell align="left" sx={commonCellStyle}>
        Action
      </TableCell>
      */}

      {headCells.map((headCell) => (
        <TableCell
          key={headCell.id}
          align="left"
          sx={commonCellStyle}
          sortDirection={orderBy === headCell.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={createSortHandler(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableHeader>
  );
};

export default TableHeading;
